import angular from 'angular';

import './footer/controller';
import './acquirers/controller';
import './device/controller';
import './header/controller';
import './invoicing_email/controller';
import './map/controller';
import './order/controller';
import './settlement/controller';
import './tax_invoice/controller';
import './merchant_admin/controller';
import './language_selector/controller';

angular.module("merchant.application.module", [
]).controller("merchant.application.module.controller", [
    "$scope",
    function($scope) {

        if (! $scope.model) {
            $scope.model = {};
        }

    }
]);
